import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Snackbar } from './Snackbar';
import { ShowSnackbarOptions } from './types';

const SNACKBAR_ROOT_ID = 'snackbar-root';

let snackbarContainer: HTMLDivElement | null = null;
let snackbarRoot: Root | null = null;

const ensureRoot = () => {
  if (snackbarContainer && snackbarRoot) {
    return snackbarRoot;
  }

  const existingContainer = document.getElementById(SNACKBAR_ROOT_ID);

  if (existingContainer?.parentNode) {
    existingContainer.parentNode.removeChild(existingContainer);
  }

  snackbarContainer = document.createElement('div');
  snackbarContainer.id = SNACKBAR_ROOT_ID;
  document.body.appendChild(snackbarContainer);
  snackbarRoot = createRoot(snackbarContainer);

  return snackbarRoot;
};

const cleanupRoot = () => {
  snackbarRoot?.unmount();
  snackbarRoot = null;

  if (snackbarContainer?.parentNode) {
    snackbarContainer.parentNode.removeChild(snackbarContainer);
  }

  snackbarContainer = null;
};

export const snackbarManager = {
  show: (options: ShowSnackbarOptions) => {
    const root = ensureRoot();
    const {
      title,
      content,
      variant = 'success',
      position = 'top',
      anchorRef,
      offset,
      className,
    } = options;

    const handleDismissRequest = () => cleanupRoot();

    root.render(
      <Snackbar
        title={title}
        content={content}
        variant={variant}
        position={position}
        anchorRef={anchorRef}
        offset={offset}
        onDismiss={options.onDismiss}
        onDismissRequest={handleDismissRequest}
        className={className}
      />
    );
  },
  dismiss: () => {
    cleanupRoot();
  },
};
